// extracted by mini-css-extract-plugin
module.exports = {"theme":"#366cb3"};